package org.wordsapp.theme

import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

val Green500 = Color(0xFF4CAF50)
val Green600 = Color(0xFF43A047)
val Green700 = Color(0xFF388E3C)
val Green100 = Color(0xFFC8E6C9)
val Green50 = Color(0xFFE8F5E9)
val DuoGreen = Color(0xFF58C259)

val Red500 = Color(0xFFE53935)
val Orange500 = Color(0xFFFF9800)
val Blue500 = Color(0xFF2196F3)
val Gray100 = Color(0xFFF5F5F5)
val Gray400 = Color(0xFFBDBDBD)

private val LightColorScheme = lightColorScheme(
    primary = Green500,
    onPrimary = Color.White,
    primaryContainer = Green100,
    onPrimaryContainer = Green700,
    secondary = Green600,
    background = Color(0xFFFAFAFA),
    surface = Color.White,
    error = Red500,
)

@Composable
fun WordsAppTheme(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = LightColorScheme,
        content = content,
    )
}
